/* eslint-disable no-underscore-dangle -- __-prefixed keys are pcb.alpha internals */
import _ from 'lodash';

import globals from '../../../PageBuilder/globals';

const Prepare = (value) => {
  if (_.isPlainObject(value) || _.isArray(value)) return _.reduce(value, (result, property, key) => {
    if (property?.__hidden) return result;
        if (property?.__visibility && globals().PB_VISIBILITY_GROUPS && globals().PB_VISIBILITY_GROUPS !== true) {
          if (!_.intersection(globals().PB_VISIBILITY_GROUPS, property.__visibility?.show_for || []).length)
            return result;
          if (_.intersection(globals().PB_VISIBILITY_GROUPS, property.__visibility?.except_for || []).length)
            return result;
    }
    result[key] = Prepare(property);
    return result;
  }, _.isArray(value) ? [] : {});
  return value;
};

export default value => Prepare(value)

